module.exports = __webpack_public_path__ + "static/media/Diners Club.17cee0bf.svg";